// Copyright (c) 2021 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import LaborRates, {getDefaultState as getLaborRatesDefaultState} from './mass-labor-rates-request-details';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const MassLaborRateRequestStatusDetails = t.struct({
    busyCounter: BusyCounter,
    massLaborRateRequestStatusDetails: LaborRates,
    requestFiltered: LaborRates,
    searchFilters: SearchFilters
}, 'MassLaborRateRequestStatusDetails');

export const getDefaultState = () =>
    new MassLaborRateRequestStatusDetails({
        busyCounter: getBusyCounterDefaultState(),
        massLaborRateRequestStatusDetails: getLaborRatesDefaultState(),
        requestFiltered: getLaborRatesDefaultState(),
        searchFilters: getSearchFiltersDefaultState()
    });

export default MassLaborRateRequestStatusDetails;



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/state/index.js